import type { FaireProductEntity } from "../../entity_types/product";

export const p_msxrt4k3yp: FaireProductEntity = {
  token: "p_msxrt4k3yp",
  type: "product",
  name: "20-25pcs Genuine Larimar Crystal Tumbled Stones, XS",
  brandToken: "b_rt8fmuccyw",
  brandName: "Caspar Curiosities",
  imageUrl:
    "https://cdn.faire.com/fastly/41cb43d6cc5fa8cf0e8686355081c91ffcdc392cccb25403fb6c4821745cb2bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7fb2ecd6c44160112d2df32a99482e66de36dbbc2da390d97a365de531ec8bd.jpeg",
    "https://cdn.faire.com/fastly/4aa12ef7079f614e8bd923302910c7e0e3ebb6fad4c258888a7f3a3eabdc3671.jpeg",
    "https://cdn.faire.com/fastly/de9a0af05a806ba477ec8dded744897ced5681b6da728876aab14bf002a3069e.jpeg",
    "https://cdn.faire.com/fastly/031f78f7c0c79ba096eb367112e6c2c1e570dda6c8912ab02f2076f23aa80974.jpeg",
    "https://cdn.faire.com/fastly/13f642ce85bff1bf0bf417954433c5d3d861676722594712db5b492430be47f8.jpeg",
    "https://cdn.faire.com/fastly/724dbe460ddc1cfd59af85eaec5c137c69b25c53b66313478602ad5e368014bf.jpeg",
  ],
  priceDollars: 7,
  description:
    "For your consideration are these beautiful Larimar small tumbled stones from the Dominican Republic. These measure approximately .25 to .5 inch long. These are perfect for crystal grids.\n\nThis listing for for a 20 gram lot that contains approximately 20 to 25 pieces.\n\nLarimar is known as the Stone of Atlantis, the Dolphin Stone, Blue Pectolite and Stefilia's Stone. It brings about the tranquil calming energies of the skies and seas. It harmonizes body and soul and is said to contain the ancient wisdom of Atlantis. A deeply relaxing and peaceful stone. Connects with the Divine Feminine. \nChakra: Heart, Throat, Third Eye and Crown\n\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:10.799Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
